<template>
<el-dialog :title="!dataForm.userId ? '新增' : '修改'" :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
        <el-form-item label="真实姓名" prop="realName">
            <el-input v-model="dataForm.realName" placeholder="真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="账户名" prop="username">
            <el-input v-model="dataForm.username" placeholder="账户名"></el-input>
        </el-form-item>
        <el-form-item label="生日" prop="birthday">
            <el-date-picker v-model="dataForm.birthday" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="班级" prop="studentGroupId">
            <el-dict-select placeholder="班级" v-model="dataForm.studentGroupId" type="studentGroups" :props="{ label: 'groupName', value: 'id' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="学段" prop="userStage">
            <el-dict-select placeholder="学段" v-model="dataForm.userStage" type="openDict" :props="dictProps" :params="groupStageParams"></el-dict-select>
        </el-form-item>
        <el-form-item label="阶段" prop="userStageLevel">
            <el-dict-select v-model="dataForm.userStageLevel" placeholder="阶段" type="openDict" :props="dictProps" :params="userStageLevelParams"></el-dict-select>
        </el-form-item>

        <el-form-item label="性别" prop="gender">
            <el-dict-select v-model="dataForm.gender" placeholder="性别" type="listByType" :params="genderParams" :props="dictProps"></el-dict-select>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
            <el-input v-model="dataForm.mobile" placeholder="手机号/家长手机号"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" placeholder="备注：学校/住址/家长姓名/是否试听"></el-input>
        </el-form-item>
        <!--
        <el-form-item label="邮箱" prop="email">
            <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
        </el-form-item>
              <el-form-item label="状态" size="mini" prop="status">
        <el-radio-group v-model="dataForm.status">
          <el-radio label="0">禁用</el-radio>
          <el-radio label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>-->
    </el-form>
    <span slot="footer" class="dialog-footer">
        <span style="margin-right: 300px; font-size: xx-small" v-if="!dataForm.userId"><span style="color: red">注意事项</span>: 新增用户默认密码 456123，为了防止盗号，请尽快修改！</span>
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()" :loading="loading">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,
            dataForm: {
                username: undefined,
                realName: undefined,
                gender: undefined,
                remark: undefined,
                mobile: undefined,
                birthday: undefined,
                studentGroupId: undefined,
                userStage: undefined,
                userStageLevel: undefined,
                roleIdList: undefined,
                status: '1',
            },
            dataRule: {
                realName: [{
                    required: true,
                    message: "姓名不能为空",
                    trigger: "blur"
                }, ],
                username: [{
                    required: true,
                    message: "请输入账户名",
                    trigger: "blur"
                }, ],
                birthday: [{
                    required: true,
                    message: "请输入生日",
                    trigger: "blur"
                }, ],
                mobile: [{
                    required: true,
                    message: "请输入手机号/家长手机号",
                    trigger: "blur"
                }, ],
                gender: [{
                    required: true,
                    message: "性别不能为空",
                    trigger: "blur"
                }, ],
            },
        };
    },
    methods: {
        init(userId) {
            this.dataForm.userId = userId;
            this.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.userId) {
                    this.$http({
                        url: this.$http.adornUrl(`sys/user/info/${this.dataForm.userId}`),
                        method: "get",
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.dataForm.username = data.user.username;
                            this.dataForm.realName = data.user.realName;
                            this.dataForm.gender = data.user.gender;
                            this.dataForm.birthday = data.user.birthday;
                            this.dataForm.remark = data.user.remark;
                            this.dataForm.mobile = data.user.mobile;
                            this.dataForm.status = data.user.status;
                            this.dataForm.studentGroupId = data.user.studentGroupId;
                            this.dataForm.userStage = data.user.userStage;
                            this.dataForm.remark = data.user.remark;
                            this.$nextTick(() => {
                                this.dataForm.roleIdList = data.user.roleIdList;
                                this.dataForm.userStageLevel = data.user.userStageLevel;
                            });
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.$http({
                            url: this.$http.adornUrl(
                                `/sys/user/${
                !this.dataForm.userId
                  ? "save"
                  : "update/" + this.dataForm.userId
              }`
                            ),
                            method: `${this.dataForm.userId ? "put" : "post"}`,
                            data: this.$http.adornData({
                                ...this.dataForm,
                                userType: "STUDENT",
                            }),
                        })
                        .then(({
                            data
                        }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: this.dataForm.userId ? "更新成功" : "新建成功",
                                    type: "success",
                                });
                                this.visible = false;
                                this.$emit("refreshDataList");
                            } else {
                                this.$message.error(data.msg);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
    },
    computed: {
        dictProps() {
            return {
                label: "value",
                value: "code"
            };
        },
        genderParams() {
            return {
                type: "Gender"
            };
        },
        groupStageParams() {
            return {
                type: "StudentStage",
                orgId: this.dataForm.orgId
            };
        },
        userStageLevelParams() {
            return {
                type: this.dataForm.userStage,
                orgId: this.dataForm.orgId,
            };
        },
        rolelistParams() {
            return {
                orgId: this.dataForm.orgId,
            };
        },
    },
};
</script>
